import React from 'react';
import { Link } from 'react-router-dom';

export default function Header() {
  return (
    <header className="border-b border-[#DCE3EC] bg-[#F5F8FB]">
      <div className="reading-column px-4 py-4 flex items-center justify-between">
        <Link 
          to="/" 
          className="text-lg font-bold text-[#141B22] tracking-tight hover:text-[#2A4DB0]"
        >
          Kanmanfryse.dk
        </Link>
        <nav className="flex items-center space-x-4 sm:space-x-6 text-[15px] font-medium text-[#5C6670]">
          <Link 
            to="/saadan-fryser-du-mad" 
            className="hover:text-[#2A4DB0] hover:underline transition-colors"
          >
            Sådan fryser du
          </Link>
          <span className="text-[#DCE3EC]">·</span>
          <Link 
            to="/optoening" 
            className="hover:text-[#2A4DB0] hover:underline transition-colors"
          >
            Optøning
          </Link>
          <span className="text-[#DCE3EC]">·</span>
          <Link 
            to="/#alfabetisk" 
            className="hover:text-[#2A4DB0] hover:underline transition-colors"
          >
            A–Å
          </Link>
        </nav>
      </div>
    </header>
  );
}
